<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="daobit-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-close-on-backdrop
    no-header
    @shown="getData"
    @hidden="resetSidebarData"
    shadow
    :width="sidebarWidth"
    ref="daobitPriceSidebar"
    :title="addPrice ? 'Добавление прайса Даобит' : 'Редактирование прайса Даобит'">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление прайса Даобит</h2>
          <h2 v-else class="my-4">Редактирование прайса Даобит</h2>
          <b-row>
            <b-col>
              <b-form-group
                label="Месяц с которой действует"
                label-for="dateStart"
                label-class="mf-label"
              >
                <a-month-picker
                  class="mr-3"
                  size="large"
                  v-model="dateStart"
                  :disabled="disabled"
                  format="MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
          </b-row>
          <h4 class="form-title">Пакеты</h4>
          <b-row>
            <b-col xl="6">
              <b-table
                id="data_table"
                ref="pricesDefault"
                hover
                :fields="fieldsDefault"
                :items="modelDefault"
              >
                <template v-slot:cell(packageName)="data">
                  <b>{{ data.item.packageName }}</b>
                </template>
                <template v-slot:cell(range1)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PIdefault-input"
                      name="ПИ (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (1-10)"
                      v-model="modelDefault[0].range1PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PNPdefault-input"
                      name="ПНП (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (1-10)"
                      v-model="modelDefault[1].range1PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1ETDdefault-input"
                      name="ЭТД (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (1-10)"
                      v-model="modelDefault[2].range1ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PDSdefault-input"
                      name="ПДС (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (1-10)"
                      v-model="modelDefault[3].range1PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1SVHMPdefault-input"
                      name="СВХ МП (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (1-10)"
                      v-model="modelDefault[4].range1SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (1-10)"
                      v-model="modelDefault[5].range1OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1SVHOEZdefault-input"
                      name="СВХ ОЭЗ (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (1-10)"
                      v-model="modelDefault[6].range1SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PTDdefault-input"
                      name="ПТД (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (1-10)"
                      v-model="modelDefault[7].range1PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (1-10)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1DEPdefault-input"
                      name="Уведомление об убытии (1-10)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (1-10)"
                      v-model="modelDefault[8].range1DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (1-10)')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range2)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PIdefault-input"
                      name="ПИ (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (11-20)"
                      v-model="modelDefault[0].range2PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PNPdefault-input"
                      name="ПНП (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (11-20)"
                      v-model="modelDefault[1].range2PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2ETDdefault-input"
                      name="ЭТД (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (11-20)"
                      v-model="modelDefault[2].range2ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PDSdefault-input"
                      name="ПДС (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (11-20)"
                      v-model="modelDefault[3].range2PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2SVHMPdefault-input"
                      name="СВХ МП (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (11-20)"
                      v-model="modelDefault[4].range2SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (11-20)"
                      v-model="modelDefault[5].range2OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2SVHOEZdefault-input"
                      name="СВХ ОЭЗ (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (11-20)"
                      v-model="modelDefault[6].range2SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (11-20)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PTDdefault-input"
                      name="ПТД (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (11-20)"
                      v-model="modelDefault[7].range2PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (11-20)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (11-20)')"
                    style="margin-bottom: 0">
                    <b-form-input id="range2DEPdefault-input"
                      name="Уведомление об убытии (11-20)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (11-20)"
                      v-model="modelDefault[8].range2DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (11-20)')"></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range3)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PIdefault-input"
                      name="ПИ (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (21-50)"
                      v-model="modelDefault[0].range3PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PNPdefault-input"
                      name="ПНП (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (21-50)"
                      v-model="modelDefault[1].range3PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3ETDdefault-input"
                      name="ЭТД (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (21-50)"
                      v-model="modelDefault[2].range3ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PDSdefault-input"
                      name="ПДС (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (21-50)"
                      v-model="modelDefault[3].range3PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3SVHMPdefault-input"
                      name="СВХ МП (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (21-50)"
                      v-model="modelDefault[4].range3SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (21-50)"
                      v-model="modelDefault[5].range3OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3SVHOEZdefault-input"
                      name="СВХ ОЭЗ (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (21-50)"
                      v-model="modelDefault[6].range3SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (21-50)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PTDdefault-input"
                      name="ПТД (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (21-50)"
                      v-model="modelDefault[7].range3PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (21-50)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (21-50)')"
                    style="margin-bottom: 0">
                    <b-form-input id="range3DEPdefault-input"
                      name="Уведомление об убытии (21-50)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (21-50)"
                      v-model="modelDefault[8].range3DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (21-50)')"></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range4)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PIdefault-input"
                      name="ПИ (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (51-100)"
                      v-model="modelDefault[0].range4PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PNPdefault-input"
                      name="ПНП (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (51-100)"
                      v-model="modelDefault[1].range4PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4ETDdefault-input"
                      name="ЭТД (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (51-100)"
                      v-model="modelDefault[2].range4ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PDSdefault-input"
                      name="ПДС (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (51-100)"
                      v-model="modelDefault[3].range4PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4SVHMPdefault-input"
                      name="СВХ МП (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (51-100)"
                      v-model="modelDefault[4].range4SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (51-100)"
                      v-model="modelDefault[5].range4OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4SVHOEZdefault-input"
                      name="СВХ ОЭЗ (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (51-100)"
                      v-model="modelDefault[6].range4SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (51-100)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PTDdefault-input"
                      name="ПТД (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (51-100)"
                      v-model="modelDefault[7].range4PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (51-100)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (51-100)')"
                    style="margin-bottom: 0">
                    <b-form-input id="range4DEPdefault-input"
                      name="Уведомление об убытии (51-100)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (51-100)"
                      v-model="modelDefault[8].range4DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (51-100)')"></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range5)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PIdefault-input"
                      name="ПИ (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (101-200)"
                      v-model="modelDefault[0].range5PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PNPdefault-input"
                      name="ПНП (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (101-200)"
                      v-model="modelDefault[1].range5PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5ETDdefault-input"
                      name="ЭТД (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (101-200)"
                      v-model="modelDefault[2].range5ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PDSdefault-input"
                      name="ПДС (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (101-200)"
                      v-model="modelDefault[3].range5PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5SVHMPdefault-input"
                      name="СВХ МП (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (101-200)"
                      v-model="modelDefault[4].range5SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (101-200)"
                      v-model="modelDefault[5].range5OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5SVHOEZdefault-input"
                      name="СВХ ОЭЗ (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (101-200)"
                      v-model="modelDefault[6].range5SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (101-200)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PTDdefault-input"
                      name="ПТД (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (101-200)"
                      v-model="modelDefault[7].range5PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (101-200)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (101-200)')"
                    style="margin-bottom: 0">
                    <b-form-input id="range5DEPdefault-input"
                      name="Уведомление об убытии (101-200)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (101-200)"
                      v-model="modelDefault[8].range5DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (101-200)')"></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range6)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PIdefault-input"
                      name="ПИ (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (200+)"
                      v-model="modelDefault[0].range6PIdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PNPdefault-input"
                      name="ПНП (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (200+)"
                      v-model="modelDefault[1].range6PNPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6ETDdefault-input"
                      name="ЭТД (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (200+)"
                      v-model="modelDefault[2].range6ETDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PDSdefault-input"
                      name="ПДС (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (200+)"
                      v-model="modelDefault[3].range6PDSdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6SVHMPdefault-input"
                      name="СВХ МП (200+)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (200+)"
                      v-model="modelDefault[4].range6SVHMPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6OEZdefault-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (200+)"
                      v-model="modelDefault[5].range6OEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6SVHOEZdefault-input"
                      name="СВХ ОЭЗ (200+)"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (200+)"
                      v-model="modelDefault[6].range6SVHOEZdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (200+)')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PTDdefault-input"
                      name="ПТД (200+)"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (200+)"
                      v-model="modelDefault[7].range6PTDdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (200+)')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (200+)')"
                    style="margin-bottom: 0">
                    <b-form-input id="range6DEPdefault-input"
                      name="Уведомление об убытии (200+)"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (200+)"
                      v-model="modelDefault[8].range6DEPdefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (200+)')"></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col xl="6">
              <b-table
                id="data_table"
                hover
                ref="pricesRecalc"
                :fields="fieldsRecalc"
                :items="modelRecalc"
              >
                <template v-slot:cell(range1)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PIrecalc-input"
                      name="ПИ (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (1-10) пересчет"
                      v-model="modelRecalc[0].range1PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PNPrecalc-input"
                      name="ПНП (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (1-10) пересчет"
                      v-model="modelRecalc[1].range1PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1ETDrecalc-input"
                      name="ЭТД (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (1-10) пересчет"
                      v-model="modelRecalc[2].range1ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PDSrecalc-input"
                      name="ПДС (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (1-10) пересчет"
                      v-model="modelRecalc[3].range1PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1SVHMPrecalc-input"
                      name="СВХ МП (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (1-10) пересчет"
                      v-model="modelRecalc[4].range1SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (1-10) пересчет"
                      v-model="modelRecalc[5].range1OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (1-10) пересчет"
                      v-model="modelRecalc[6].range1SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1PTDrecalc-input"
                      name="ПТД (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (1-10) пересчет"
                      v-model="modelRecalc[7].range1PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (1-10) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range1DEPrecalc-input"
                      name="Уведомление об убытии (1-10) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (1-10) пересчет"
                      v-model="modelRecalc[8].range1DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (1-10) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range2)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PIrecalc-input"
                      name="ПИ (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (11-20) пересчет"
                      v-model="modelRecalc[0].range2PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PNPrecalc-input"
                      name="ПНП (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (11-20) пересчет"
                      v-model="modelRecalc[1].range2PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2ETDrecalc-input"
                      name="ЭТД (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (11-20) пересчет"
                      v-model="modelRecalc[2].range2ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PDSrecalc-input"
                      name="ПДС (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (11-20) пересчет"
                      v-model="modelRecalc[3].range2PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2SVHMPrecalc-input"
                      name="СВХ МП (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (11-20) пересчет"
                      v-model="modelRecalc[4].range2SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (11-20) пересчет"
                      v-model="modelRecalc[5].range2OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (11-20) пересчет"
                      v-model="modelRecalc[6].range2SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2PTDrecalc-input"
                      name="ПТД (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (11-20) пересчет"
                      v-model="modelRecalc[7].range2PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (11-20) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range2DEPrecalc-input"
                      name="Уведомление об убытии (11-20) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (11-20) пересчет"
                      v-model="modelRecalc[8].range2DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (11-20) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range3)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PIrecalc-input"
                      name="ПИ (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (21-50) пересчет"
                      v-model="modelRecalc[0].range3PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PNPrecalc-input"
                      name="ПНП (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (21-50) пересчет"
                      v-model="modelRecalc[1].range3PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3ETDrecalc-input"
                      name="ЭТД (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (21-50) пересчет"
                      v-model="modelRecalc[2].range3ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PDSrecalc-input"
                      name="ПДС (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (21-50) пересчет"
                      v-model="modelRecalc[3].range3PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3SVHMPrecalc-input"
                      name="СВХ МП (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (21-50) пересчет"
                      v-model="modelRecalc[4].range3SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (21-50) пересчет"
                      v-model="modelRecalc[5].range3OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (21-50) пересчет"
                      v-model="modelRecalc[6].range3SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3PTDrecalc-input"
                      name="ПТД (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (21-50) пересчет"
                      v-model="modelRecalc[7].range3PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (21-50) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range3DEPrecalc-input"
                      name="Уведомление об убытии (21-50) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (21-50) пересчет"
                      v-model="modelRecalc[8].range3DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (21-50) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range4)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PIrecalc-input"
                      name="ПИ (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (51-100) пересчет"
                      v-model="modelRecalc[0].range4PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PNPrecalc-input"
                      name="ПНП (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (51-100) пересчет"
                      v-model="modelRecalc[1].range4PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4ETDrecalc-input"
                      name="ЭТД (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (51-100) пересчет"
                      v-model="modelRecalc[2].range4ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PDSrecalc-input"
                      name="ПДС (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (51-100) пересчет"
                      v-model="modelRecalc[3].range4PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4SVHMPrecalc-input"
                      name="СВХ МП (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (51-100) пересчет"
                      v-model="modelRecalc[4].range4SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (51-100) пересчет"
                      v-model="modelRecalc[5].range4OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (51-100) пересчет"
                      v-model="modelRecalc[6].range4SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4PTDrecalc-input"
                      name="ПТД (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (51-100) пересчет"
                      v-model="modelRecalc[7].range4PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (51-100) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range4DEPrecalc-input"
                      name="Уведомление об убытии (51-100) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (51-100) пересчет"
                      v-model="modelRecalc[8].range4DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (51-100) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range5)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PIrecalc-input"
                      name="ПИ (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (101-200) пересчет"
                      v-model="modelRecalc[0].range5PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PNPrecalc-input"
                      name="ПНП (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (101-200) пересчет"
                      v-model="modelRecalc[1].range5PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5ETDrecalc-input"
                      name="ЭТД (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (101-200) пересчет"
                      v-model="modelRecalc[2].range5ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PDSrecalc-input"
                      name="ПДС (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (101-200) пересчет"
                      v-model="modelRecalc[3].range5PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5SVHMPrecalc-input"
                      name="СВХ МП (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (101-200) пересчет"
                      v-model="modelRecalc[4].range5SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (101-200) пересчет"
                      v-model="modelRecalc[5].range5OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (101-200) пересчет"
                      v-model="modelRecalc[6].range5SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5PTDrecalc-input"
                      name="ПТД (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (101-200) пересчет"
                      v-model="modelRecalc[7].range5PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (101-200) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range5DEPrecalc-input"
                      name="Уведомление об убытии (101-200) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (101-200) пересчет"
                      v-model="modelRecalc[8].range5DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (101-200) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(range6)="data">
                  <b-form-group
                    v-if="data.item.packageName === 'ПИ'"
                    :invalid-feedback="getError('ПИ (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PIrecalc-input"
                      name="ПИ (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПИ (200+) пересчет"
                      v-model="modelRecalc[0].range6PIrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПИ (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПНП'"
                    :invalid-feedback="getError('ПНП (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PNPrecalc-input"
                      name="ПНП (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПНП (200+) пересчет"
                      v-model="modelRecalc[1].range6PNPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПНП (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ЭТД'"
                    :invalid-feedback="getError('ЭТД (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6ETDrecalc-input"
                      name="ЭТД (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ЭТД (200+) пересчет"
                      v-model="modelRecalc[2].range6ETDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ЭТД (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПДС'"
                    :invalid-feedback="getError('ПДС (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PDSrecalc-input"
                      name="ПДС (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПДС (200+) пересчет"
                      v-model="modelRecalc[3].range6PDSrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПДС (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ МП'"
                    :invalid-feedback="getError('СВХ МП (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6SVHMPrecalc-input"
                      name="СВХ МП (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ МП (200+) пересчет"
                      v-model="modelRecalc[4].range6SVHMPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ МП (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ОЭЗ/ПОЭЗ/ТОСЭР'"
                    :invalid-feedback="getError('ОЭЗ/ПОЭЗ/ТОСЭР (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6OEZrecalc-input"
                      name="ОЭЗ/ПОЭЗ/ТОСЭР (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ОЭЗ/ПОЭЗ/ТОСЭР (200+) пересчет"
                      v-model="modelRecalc[5].range6OEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ОЭЗ/ПОЭЗ/ТОСЭР (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'СВХ ОЭЗ'"
                    :invalid-feedback="getError('СВХ ОЭЗ (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6SVHOEZrecalc-input"
                      name="СВХ ОЭЗ (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="СВХ ОЭЗ (200+) пересчет"
                      v-model="modelRecalc[6].range6SVHOEZrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('СВХ ОЭЗ (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'ПТД'"
                    :invalid-feedback="getError('ПТД (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6PTDrecalc-input"
                      name="ПТД (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="ПТД (200+) пересчет"
                      v-model="modelRecalc[7].range6PTDrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('ПТД (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.packageName === 'Уведомление об убытии'"
                    :invalid-feedback="getError('Уведомление об убытии (200+) пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="range6DEPrecalc-input"
                      name="Уведомление об убытии (200+) пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Уведомление об убытии (200+) пересчет"
                      v-model="modelRecalc[8].range6DEPrecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Уведомление об убытии (200+) пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col><h4 class="form-title">Лицензия</h4></b-col>
            <b-col><h4 class="form-title">Вознаграждение</h4></b-col>
          </b-row>
          <b-row>
            <b-col xl="6">
              <b-table
                id="data_table"
                style="width: 60%"
                hover
                ref="licensesDefault"
                :fields="licenseFieldsDefault"
                :items="licenseModelDefault"
              >
                <template v-slot:cell(name)="data">
                  <b>{{ data.item.name }}</b>
                </template>
                <template v-slot:cell(compensation)="data">
                  <b-form-group
                    v-if="data.item.name === 'Стандартный'"
                    :invalid-feedback="getError('Вознаграждение Стандартный')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="compensationStandartDefault-input"
                      name="Вознаграждение Стандартный"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение Стандартный"
                      v-model="licenseModelDefault[0].compensationStandartDefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Вознаграждение Стандартный')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.name === 'Минимальный'"
                    :invalid-feedback="getError('Вознаграждение Минимальный')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="compensationMinDefault-input"
                      name="Вознаграждение Минимальный"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение Минимальный"
                      v-model="licenseModelDefault[1].compensationMinDefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Вознаграждение Минимальный')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(additionalLogin)="data">
                  <b-form-group
                    v-if="data.item.name === 'Стандартный'"
                    :invalid-feedback="getError('Доп. уч. запись Стандартный')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="additionalLoginStandartDefault-input"
                      name="Доп. уч. запись Стандартный"
                      v-validate="priceValidation"
                      data-vv-as="Доп. уч. запись Стандартный"
                      v-model="licenseModelDefault[0].additionalLoginStandartDefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Доп. уч. запись Стандартный')"
                    ></b-form-input>
                  </b-form-group>
                  <!-- b-form-group
                    v-if="data.item.name === 'Минимальный'"
                    :invalid-feedback="getError('Доп. уч. запись Минимальный')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="additionalLoginMinDefault-input"
                      name="Доп. уч. запись Минимальный"
                      v-validate="priceValidation"
                      data-vv-as="Доп. уч. запись Минимальный"
                      v-model="licenseModelDefault[1].additionalLoginMinDefault"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Доп. уч. запись Минимальный')"
                    ></b-form-input>
                  </b-form-group -->
                </template>
              </b-table>
            </b-col>
            <b-col xl="6">
              <b-table
                id="data_table"
                style="width: 50%"
                hover
                ref="licensesRecalc"
                :fields="licenseFieldsRecalc"
                :items="licenseModelRecalc"
              >
                <template v-slot:cell(compensation)="data">
                  <b-form-group
                    v-if="data.item.name === 'Стандартный'"
                    :invalid-feedback="getError('Вознаграждение Стандартный пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="compensationStandartRecalc-input"
                      name="Вознаграждение Стандартный пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение Стандартный пересчет"
                      v-model="licenseModelRecalc[0].compensationStandartRecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Вознаграждение Стандартный пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.name === 'Минимальный'"
                    :invalid-feedback="getError('Вознаграждение Минимальный пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="compensationMinRecalc-input"
                      name="Вознаграждение Минимальный пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение Минимальный пересчет"
                      v-model="licenseModelRecalc[1].compensationMinRecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Вознаграждение Минимальный пересчет')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(additionalLogin)="data">
                  <b-form-group
                    v-if="data.item.name === 'Стандартный'"
                    :invalid-feedback="getError('Доп. уч. запись Стандартный пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="additionalLoginStandartRecalc-input"
                      name="Доп. уч. запись Стандартный пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Доп. уч. запись Стандартный пересчет"
                      v-model="licenseModelRecalc[0].additionalLoginStandartRecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Доп. уч. запись Стандартный пересчет')"
                    ></b-form-input>
                  </b-form-group>
                  <!-- b-form-group
                    v-if="data.item.name === 'Минимальный'"
                    :invalid-feedback="getError('Доп. уч. запись Минимальный пересчет')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="additionalLoginMinRecalc-input"
                      name="Доп. уч. запись Минимальный пересчет"
                      v-validate="priceValidation"
                      data-vv-as="Доп. уч. запись Минимальный пересчет"
                      v-model="licenseModelRecalc[1].additionalLoginMinRecalc"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Доп. уч. запись Минимальный пересчет')"
                    ></b-form-input>
                  </b-form-group -->
                </template>
              </b-table>
            </b-col>
          </b-row>
          <h4 class="form-title">Вознаграждение</h4>
          <b-row>
            <b-col xl="2">
              <b-table
                id="data_table"
                hover
                ref="compensation"
                :fields="compensationFields"
                :items="compensationModel"
              >
                <template v-slot:cell(type)="data">
                  <b>{{ data.item.type }}</b>
                </template>
                <template v-slot:cell(percent)="data">
                  <b-form-group
                    v-if="data.item.type === 'Пакеты'"
                    :invalid-feedback="getError('Пакеты')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentPackages-input"
                      name="Пакеты"
                      v-validate="priceValidation"
                      data-vv-as="Пакеты"
                      v-model="compensationModel[0].percentPackages"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Пакеты')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="data.item.type === 'Лицензия'"
                    :invalid-feedback="getError('Лицензия')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentLicense-input"
                      name="Лицензия"
                      v-validate="priceValidation"
                      data-vv-as="Лицензия"
                      v-model="compensationModel[1].percentLicense"
                      :disabled="disabled"
                      placeholder=""
                      :state="validateState('Лицензия')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col class="d-flex align-items-center">
              <b-button @click="recalcPrices" :disabled="disabled" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить прайс</span>
                  <span v-else>Изменить прайс</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import moment from 'moment'

export default {
  name: 'AddDaobitPrice',
  components: {},
  props: ['addPrice', 'startMonth', 'startYear', 'disabled'],
  mixins: [validation],
  data () {
    return {
      billingAlias: 'dyn_tp',
      sidebarWidth: '',
      dateStart: null,
      fieldsDefault: [
        { key: 'packageName', label: 'Тип пакета' },
        { key: 'range1', label: '1-10' },
        { key: 'range2', label: '11-20' },
        { key: 'range3', label: '21-50' },
        { key: 'range4', label: '51-100' },
        { key: 'range5', label: '101-200' },
        { key: 'range6', label: '200+' }
      ],
      fieldsRecalc: [
        { key: 'range1', label: '1-10' },
        { key: 'range2', label: '11-20' },
        { key: 'range3', label: '21-50' },
        { key: 'range4', label: '51-100' },
        { key: 'range5', label: '101-200' },
        { key: 'range6', label: '200+' }
      ],
      modelDefault: [
        { packageName: 'ПИ', range1PIdefault: null, range2PIdefault: null, range3PIdefault: null, range4PIdefault: null, range5PIdefault: null, range6PIdefault: null },
        { packageName: 'ПНП', range1PNPdefault: null, range2PNPdefault: null, range3PNPdefault: null, range4PNPdefault: null, range5PNPdefault: null, range6PNPdefault: null },
        { packageName: 'ЭТД', range1ETDdefault: null, range2ETDdefault: null, range3ETDdefault: null, range4ETDdefault: null, range5ETDdefault: null, range6ETDdefault: null },
        { packageName: 'ПДС', range1PDSdefault: null, range2PDSdefault: null, range3PDSdefault: null, range4PDSdefault: null, range5PDSdefault: null, range6PDSdefault: null },
        { packageName: 'СВХ МП', range1SVHMPdefault: null, range2SVHMPdefault: null, range3SVHMPdefault: null, range4SVHMPdefault: null, range5SVHMPdefault: null, range6SVHMPdefault: null },
        { packageName: 'ОЭЗ/ПОЭЗ/ТОСЭР', range1OEZdefault: null, range2OEZdefault: null, range3OEZdefault: null, range4OEZdefault: null, range5OEZdefault: null, range6OEZdefault: null },
        { packageName: 'СВХ ОЭЗ', range1SVHOEZdefault: null, range2SVHOEZdefault: null, range3SVHOEZdefault: null, range4SVHOEZdefault: null, range5SVHOEZdefault: null, range6SVHOEZdefault: null },
        { packageName: 'ПТД', range1PTDdefault: null, range2PTDdefault: null, range3PTDdefault: null, range4PTDdefault: null, range5PTDdefault: null, range6PTDdefault: null },
        { packageName: 'Уведомление об убытии', range1DEPdefault: null, range2DEPdefault: null, range3DEPdefault: null, range4DEPdefault: null, range5DEPdefault: null, range6DEPdefault: null }
      ],
      freezeModelDefault: null,
      modelRecalc: [
        { packageName: 'ПИ', range1PIrecalc: null, range2PIrecalc: null, range3PIrecalc: null, range4PIrecalc: null, range5PIrecalc: null, range6PIrecalc: null },
        { packageName: 'ПНП', range1PNPrecalc: null, range2PNPrecalc: null, range3PNPrecalc: null, range4PNPrecalc: null, range5PNPrecalc: null, range6PNPrecalc: null },
        { packageName: 'ЭТД', range1ETDrecalc: null, range2ETDrecalc: null, range3ETDrecalc: null, range4ETDrecalc: null, range5ETDrecalc: null, range6ETDrecalc: null },
        { packageName: 'ПДС', range1PDSrecalc: null, range2PDSrecalc: null, range3PDSrecalc: null, range4PDSrecalc: null, range5PDSrecalc: null, range6PDSrecalc: null },
        { packageName: 'СВХ МП', range1SVHMPrecalc: null, range2SVHMPrecalc: null, range3SVHMPrecalc: null, range4SVHMPrecalc: null, range5SVHMPrecalc: null, range6SVHMPrecalc: null },
        { packageName: 'ОЭЗ/ПОЭЗ/ТОСЭР', range1OEZrecalc: null, range2OEZrecalc: null, range3OEZrecalc: null, range4OEZrecalc: null, range5OEZrecalc: null, range6OEZrecalc: null },
        { packageName: 'СВХ ОЭЗ', range1SVHOEZrecalc: null, range2SVHOEZrecalc: null, range3SVHOEZrecalc: null, range4SVHOEZrecalc: null, range5SVHOEZrecalc: null, range6SVHOEZrecalc: null },
        { packageName: 'ПТД', range1PTDrecalc: null, range2PTDrecalc: null, range3PTDrecalc: null, range4PTDrecalc: null, range5PTDrecalc: null, range6PTDrecalc: null },
        { packageName: 'Уведомление об убытии', range1DEPrecalc: null, range2DEPrecalc: null, range3DEPrecalc: null, range4DEPrecalc: null, range5DEPrecalc: null, range6DEPrecalc: null }
      ],
      freezeModelRecalc: null,
      licenseFieldsDefault: [
        { key: 'name', label: 'Наименование' },
        { key: 'compensation', label: 'Стоимость лицензии' },
        { key: 'additionalLogin', label: 'Дополнительная учётая запись' }
      ],
      licenseModelDefault: [
        { name: 'Стандартный', compensationStandartDefault: null, additionalLoginStandartDefault: null },
        { name: 'Минимальный', compensationMinDefault: null, additionalLoginMinDefault: null }
      ],
      freezeLicenseModelDefault: null,
      licenseFieldsRecalc: [
        { key: 'compensation', label: 'Лицензия' },
        { key: 'additionalLogin', label: 'Дополнительная учётая запись' }
      ],
      licenseModelRecalc: [
        { name: 'Стандартный', compensationStandartRecalc: null, additionalLoginStandartRecalc: null },
        { name: 'Минимальный', compensationMinRecalc: null, additionalLoginMinRecalc: null }
      ],
      freezeLicenseModelRecalc: null,
      compensationFields: [
        { key: 'type', label: 'Тип' },
        { key: 'percent', label: 'Процент' }
      ],
      compensationModel: [
        { type: 'Пакеты', percentPackages: null },
        { type: 'Лицензия', percentLicense: null }
      ],
      oldStartMonth: null,
      oldStartYear: null
    }
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData
      }
    )
  },
  mounted () {
    this.calcSidebarWidth()
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    getData () {
      this.freezeModelDefault = JSON.parse(JSON.stringify(this.modelDefault))
      this.freezeModelRecalc = JSON.parse(JSON.stringify(this.modelRecalc))
      this.freezeLicenseModelDefault = JSON.parse(JSON.stringify(this.licenseModelDefault))
      this.freezeLicenseModelRecalc = JSON.parse(JSON.stringify(this.licenseModelRecalc))
      if (!this.addPrice) {
        this.getDealerPrice({ month: this.startMonth, year: this.startYear, id: this.$route.params.id, billing_alias: this.billingAlias }).then(
          () => {
            console.log(this.dealerPriceData)
            this.dealerPriceData.packages.map((item) => {
              if (item.message_price_position_alias === 'pp_oez_poez_toser') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'OEZdefault'
                  this.modelDefault[5][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'OEZrecalc'
                  this.modelRecalc[5][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_pds') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PDSdefault'
                  this.modelDefault[3][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PDSrecalc'
                  this.modelRecalc[3][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_pi') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PIdefault'
                  this.modelDefault[0][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PIrecalc'
                  this.modelRecalc[0][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_pnp') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PNPdefault'
                  this.modelDefault[1][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PNPrecalc'
                  this.modelRecalc[1][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_etd') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'ETDdefault'
                  this.modelDefault[2][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'ETDrecalc'
                  this.modelRecalc[2][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_svh_mp') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'SVHMPdefault'
                  this.modelDefault[4][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'SVHMPrecalc'
                  this.modelRecalc[4][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_svh_oez') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'SVHOEZdefault'
                  this.modelDefault[6][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'SVHOEZrecalc'
                  this.modelRecalc[6][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_ptd') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PTDdefault'
                  this.modelDefault[7][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'PTDrecalc'
                  this.modelRecalc[7][key] = item.daobit_points_cost[i]
                }
              }
              if (item.message_price_position_alias === 'pp_departure') {
                for (let i = 0; i < item.client_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'DEPdefault'
                  this.modelDefault[8][key] = item.client_points_cost[i]
                }
                for (let i = 0; i < item.daobit_points_cost.length; i++) {
                  const key = 'range' + (i + 1) + 'DEPrecalc'
                  this.modelRecalc[8][key] = item.daobit_points_cost[i]
                }
              }
            })
            this.dealerPriceData.lycense.map((item) => {
              if (item.price_position === 'tpp_dynamic_minimum') {
                this.licenseModelDefault[1].compensationMinDefault = item.client_price
                this.licenseModelDefault[1].additionalLoginMinDefault = item.client_additional_account_price
                this.licenseModelRecalc[1].compensationMinRecalc = item.daobit_price
                this.licenseModelRecalc[1].additionalLoginMinRecalc = item.daobit_additional_account_price
              }
              if (item.price_position === 'tpp_dynamic_standard') {
                this.licenseModelDefault[0].compensationStandartDefault = item.client_price
                this.licenseModelDefault[0].additionalLoginStandartDefault = item.client_additional_account_price
                this.licenseModelRecalc[0].compensationStandartRecalc = item.daobit_price
                this.licenseModelRecalc[0].additionalLoginStandartRecalc = item.daobit_additional_account_price
              }
            })
            this.calcPackagesPercent()
            this.calcLicensePercent()
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.oldStartMonth = this.startMonth
            this.oldStartYear = this.startYear
          }
        )
      } else {
        this.dateStart = null
      }
    },
    calcPackagesPercent () {
      const percents = []
      this.dealerPriceData.packages.map((item) => {
        for (let i = 0; i < item.client_points_cost.length; i++) {
          const percent = parseFloat((item.daobit_points_cost[i] * 100 / item.client_points_cost[i]).toFixed(2))
          percents.push(percent)
        }
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModel[0].percentPackages = Object.keys(counts)[0]
    },
    calcLicensePercent () {
      const percents = []
      this.dealerPriceData.lycense.map((item) => {
        percents.push(parseFloat((item.daobit_price * 100 / item.client_price).toFixed(2)))
        percents.push(parseFloat((item.daobit_additional_account_price * 100 / item.client_additional_account_price).toFixed(2)))
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModel[1].percentLicense = Object.keys(counts)[0]
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelDefault.map((item, index) => {
        const defaultKeys = Object.keys(item)
        const recalcKeys = Object.keys(this.modelRecalc[index])
        for (let i = 0; i < defaultKeys.length; i++) {
          if (i > 0) {
            if ((this.modelDefault[index][defaultKeys[i]] !== '') && (this.modelDefault[index][defaultKeys[i]] !== null)) {
              this.modelRecalc[index][recalcKeys[i]] = parseFloat(this.percentage(this.compensationModel[0].percentPackages, this.modelDefault[index][defaultKeys[i]]))
            }
          }
        }
      })
      this.licenseModelDefault.map((item, index) => {
        const defaultKeys = Object.keys(item)
        const recalcKeys = Object.keys(this.licenseModelRecalc[index])
        for (let i = 0; i < defaultKeys.length; i++) {
          if (i > 0) {
            if ((this.licenseModelDefault[index][defaultKeys[i]] !== '') && (this.licenseModelDefault[index][defaultKeys[i]] !== null)) {
              this.licenseModelRecalc[index][recalcKeys[i]] = parseFloat(this.percentage(this.compensationModel[1].percentLicense, this.licenseModelDefault[index][defaultKeys[i]]))
            }
          }
        }
      })
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '100%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    saveFormData () {
      const data = {
        year: null,
        month: null,
        year_new: null,
        month_new: null,
        // percent_lycense: this.compensationModel[1].percentLicense ? parseFloat(this.compensationModel[1].percentLicense) : null,
        // percent_packages: this.compensationModel[0].percentPackages ? parseFloat(this.compensationModel[0].percentPackages) : null,
        lycense: [
          {
            price_position: 'tpp_dynamic_standard',
            client_price: parseFloat(this.licenseModelDefault[0].compensationStandartDefault),
            daobit_price: parseFloat(this.licenseModelRecalc[0].compensationStandartRecalc),
            client_additional_account_price: parseFloat(this.licenseModelDefault[0].additionalLoginStandartDefault),
            daobit_additional_account_price: parseFloat(this.licenseModelRecalc[0].additionalLoginStandartRecalc)
          },
          {
            price_position: 'tpp_dynamic_minimum',
            client_price: parseFloat(this.licenseModelDefault[1].compensationMinDefault),
            daobit_price: parseFloat(this.licenseModelRecalc[1].compensationMinRecalc),
            client_additional_account_price: parseFloat(this.licenseModelDefault[1].additionalLoginMinDefault),
            daobit_additional_account_price: parseFloat(this.licenseModelRecalc[1].additionalLoginMinRecalc)
          }
        ],
        packages: [
          {
            message_price_position_alias: 'pp_pi',
            client_points_cost: Object.values(this.modelDefault[0]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[0]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_pnp',
            client_points_cost: Object.values(this.modelDefault[1]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[1]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_etd',
            client_points_cost: Object.values(this.modelDefault[2]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[2]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_pds',
            client_points_cost: Object.values(this.modelDefault[3]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[3]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_svh_mp',
            client_points_cost: Object.values(this.modelDefault[4]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[4]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_oez_poez_toser',
            client_points_cost: Object.values(this.modelDefault[5]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[5]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_svh_oez',
            client_points_cost: Object.values(this.modelDefault[6]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[6]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_ptd',
            client_points_cost: Object.values(this.modelDefault[7]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[7]).filter((item, index) => index !== 0)
          },
          {
            message_price_position_alias: 'pp_departure',
            client_points_cost: Object.values(this.modelDefault[8]).filter((item, index) => index !== 0).map((i) => parseFloat(i)),
            daobit_points_cost: Object.values(this.modelRecalc[8]).filter((item, index) => index !== 0)
          }
        ]
      }

      const year = this.dateStart.toDate().getFullYear()
      const month = this.dateStart.toDate().getMonth() + 1

      if (this.addPrice) {
        data.year = year
        data.month = month
      } else {
        data.year_new = year
        data.month_new = month
        data.year = this.oldStartYear
        data.month = this.oldStartMonth
      }
      if (this.addPrice) {
        this.saveDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          (response) => {
            console.log('response ', response)
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.daobitPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          () => {
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.daobitPriceSidebar.hide()
          }
        )
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.modelDefault = this.freezeModelDefault
        this.modelRecalc = this.freezeModelRecalc
        this.licenseModelDefault = this.freezeLicenseModelDefault
        this.licenseModelRecalc = this.freezeLicenseModelRecalc
        this.compensationModel[0].percentPackages = null
        this.compensationModel[1].percentLicense = null
        this.setPrice(null)
      }, 200)
    },
    ...mapActions('dealers', [
      'saveDealerPrice',
      'getDealerPrice',
      'updateDealerPrice',
      'getDealerPricesData'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>
